import React, { useState, useEffect } from "react";
import { Form, Row, Col, Switch, Icon, Divider, Typography } from "antd";
import { Formik } from "formik";
import * as Yup from "yup";
import FormInput from "components/FormItems/FormInput";
import FormSelectInput from "components/FormItems/FormSelectInput";
import FormCheckBoxInput from "components/FormItems/FormCheckBoxInput";
import FormInputWithButton from "components/FormItems/FormInputWithButton";
import AppTable from "components/AppTable/AppTable";
import { fileSchedulerProfiles, contactLimit } from "constant/commonList";
import AppButton from "components/AppButton/AppButton";
import { getFormatedContact, validAusNumberRegExpDeluxe } from "constant/messageConstants";
import AccountTable from "../AdminTable/AccountTable";

const UserSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required!")
    .matches(/\D/, "Can Not Enter Only Numbers"),
  email: Yup.string()
    .required("Email is required!")
    .nullable(true),
  mobile: Yup.string()
    .matches(validAusNumberRegExpDeluxe, "Please enter a valid phone number")
    .nullable(true),
  currency: Yup.string().required("Currency is required!"),
  mobileSender: Yup.string().matches(/\D/)
});

const UserForm = props => {
  const { readMode = false, onClose, user, fetchCurrencies, onSubmit } = props;
  const [currencyList, setCurrencyList] = useState([]);

  useEffect(() => {
    fetchCurrencies().then(({ data }) => setCurrencyList(data));
  }, []);

  const finalSubmit = async (values, setSubmitting) => {
    if (values?.email) {
      values.email = values.email.toLowerCase();
    }
    const userData = {
      ...values
    };
    console.log("click save");
    await onSubmit(userData, user && user._id ? user._id : "").finally(res => {
      onClose();
      setSubmitting(false);
    });
  };

  let tempArr = [];

  const initialValues = user || {};

  return (
    <>
      <Formik enableReinitialize initialValues={initialValues} validationSchema={UserSchema} onSubmit={(values, { setSubmitting }) => finalSubmit(values, setSubmitting)}>
        {({ values, errors, touched, handleChange, handleSubmit, isSubmitting, setFieldValue }) => {
          values.autoCreditRate = values.autoCreditRate || {
            sms: 4.5,
            mms: 39
          };
          values.contactLimit = values.contactLimit || 5000;
          values.profile = values.profile || "common";
          return (
            <Form onSubmit={handleSubmit}>
              <Row gutter={20}>
                <Col span={24}>
                  <Typography.Title level={4}>User Details</Typography.Title>
                </Col>
                <Col span={12}>
                  <FormInput
                    containerClassname="mb-0"
                    placeholder="Enter User Name"
                    error={errors.name}
                    touched={touched.name}
                    label="Name"
                    value={values.name}
                    onChange={handleChange}
                    name="name"
                    size="default"
                    disabled={readMode}
                  />
                </Col>
                <Col span={12}>
                  <FormInput
                    containerClassname="mb-0"
                    placeholder="Enter Email"
                    error={errors.email}
                    touched={touched.email}
                    label="Email"
                    value={values.email}
                    onChange={handleChange}
                    name="email"
                    size="default"
                    disabled={readMode}
                  />
                </Col>
                <Col span={24}>
                  <FormInput
                    containerClassname="mb-0"
                    placeholder="Enter Mobile"
                    error={errors.mobile}
                    touched={touched.mobile}
                    label="Mobile"
                    value={values.mobile}
                    onChange={({ target: { value } }) => setFieldValue("mobile", getFormatedContact(value))}
                    name="mobile"
                    size="default"
                    disabled={readMode}
                  />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={12}>
                  <FormInput
                    containerClassname="mb-0"
                    placeholder="Enter Password"
                    error={errors.password}
                    touched={touched.password}
                    label="Password"
                    value={values.password}
                    onChange={handleChange}
                    name="password"
                    size="default"
                    disabled={readMode}
                  />
                </Col>
                <Col span={12}>
                  <FormSelectInput
                    containerClassname="mb-0"
                    label="Profile"
                    name="profile"
                    placeholder="Select custom profile"
                    options={fileSchedulerProfiles.map(profile => ({
                      label: profile,
                      value: profile
                    }))}
                    onChange={value => setFieldValue("profile", value)}
                    value={values.profile}
                    error={errors.profile}
                    touched={touched.profile}
                    size="default"
                    disabled={readMode}
                  />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={12}>
                  <FormSelectInput
                    containerClassname="mb-0"
                    label="Currency"
                    name="currency"
                    placeholder="Select Currency"
                    options={currencyList.map(currency => ({
                      label: `${currency.symbol && currency.symbol.length > 0 ? currency.symbol[0] + " -" : ""} ${currency.country}`,
                      value: currency._id
                    }))}
                    onChange={value => setFieldValue("currency", value)}
                    value={values.currency}
                    error={errors.currency}
                    touched={touched.currency}
                    size="default"
                    disabled={readMode}
                  />
                </Col>
                <Col span={12}>
                  <FormSelectInput
                    containerClassname="mb-0"
                    label="Contact Limit"
                    name="contactLimit"
                    placeholder="Select Contact Limit"
                    options={contactLimit.map(limit => ({
                      label: limit.label,
                      value: limit.value
                    }))}
                    onChange={value => setFieldValue("contactLimit", value)}
                    value={values.contactLimit}
                    error={errors.contactLimit}
                    touched={touched.contactLimit}
                    size="default"
                    disabled={readMode}
                  />
                </Col>
              </Row>
              {readMode && values.adminAccount && (
                <>
                  <Divider />
                  <Row gutter={20}>
                    <Col span={24}>
                      <Typography.Title level={4}>Admin Account</Typography.Title>
                    </Col>
                    <Col span={24} className="mt-4">
                      <AccountTable dataSource={[values.adminAccount]} />
                    </Col>
                  </Row>
                </>
              )}
              {readMode && values.subAccount && values.subAccount.length > 0 && (
                <>
                  <Divider />
                  <Row gutter={20}>
                    <Col span={24}>
                      <Typography.Title level={4}>Sub Accounts</Typography.Title>
                    </Col>
                    <Col span={24} className="mt-4">
                      <AccountTable dataSource={values.subAccount} />
                    </Col>
                  </Row>
                </>
              )}
              <Divider />
              {/* <Row gutter={[20, 20]}>
                <Col span={24}>
                  <Typography.Title level={4}>Sender IDs</Typography.Title>
                </Col>
                <Col span={24}>
                  <FormInputWithButton
                    size="default"
                    inputProps={{
                      name: "mobileSender",
                      value: values.mobileSender,
                      onChange: handleChange,
                      placeholder: "Add Dedicated Number e.g. 614XXXXXXXX",
                      disabled: readMode,
                      containerClassname: "mb-0"
                    }}
                    buttonProps={{
                      label: "Add",
                      prefixIcon: <i className="fas fa-plus me-2" />,
                      onClick: () => {
                        let tempVal = values.mobileSender?.trim();
                        if (tempVal) {
                          tempArr = [...values.mobileSenders];
                          tempArr.push(values.mobileSender);
                          setFieldValue("mobileSenders", tempArr);
                          setFieldValue("mobileSender", "");
                        }
                        return;
                      }
                    }}
                  />
                </Col>
                <Col span={24}>
                  {values.mobileSenders && values.mobileSenders.length > 0 && (
                    <AppTable
                      columns={[
                        {
                          title: "Dedicated Numbers",
                          dataIndex: "mobileSender",
                          key: "mobileSender",
                          render: (text, record, index) => (
                            <div className="d-flex align-items-center">
                              <span>{text}</span>
                              {!readMode && (
                                <i
                                  id={`sender-${index}`}
                                  className="fas fa-trash-alt ms-auto"
                                  aria-hidden="true"
                                  onClick={e => {
                                    tempArr = [...values.mobileSenders];
                                    tempArr.splice(index, 1);
                                    setFieldValue("mobileSenders", tempArr);
                                  }}
                                />
                              )}
                            </div>
                          )
                        }
                      ]}
                      dataSource={values.mobileSenders.map(number => {
                        return { mobileSender: number };
                      })}
                      pagination={false}
                      bordered
                    />
                  )}
                </Col>
                <Col span={24}>
                  <FormInputWithButton
                    size="default"
                    inputProps={{
                      name: "sender",
                      value: values.sender,
                      onChange: handleChange,
                      placeholder: "Add Business Name e.g. SMSBump",
                      disabled: readMode,
                      containerClassname: "mb-0"
                    }}
                    buttonProps={{
                      label: "Add",
                      prefixIcon: <i className="fas fa-plus me-2" />,
                      onClick: () => {
                        let tempVal = values.sender?.trim();
                        if (tempVal) {
                          tempArr = [...values.senders];
                          tempArr.push(values.sender);
                          setFieldValue("senders", tempArr);
                          setFieldValue("sender", "");
                        }
                        return;
                      }
                    }}
                  />
                </Col>
                <Col span={24}>
                  {values.senders && values.senders.length > 0 && (
                    <AppTable
                      columns={[
                        {
                          title: "Business Names",
                          dataIndex: "sender",
                          key: "sender",
                          render: (text, record, index) => (
                            <div className="d-flex align-items-center">
                              <span>{text}</span>
                              {!readMode && (
                                <i
                                  id={`sender-${index}`}
                                  className="fas fa-trash-alt ms-auto"
                                  aria-hidden="true"
                                  onClick={e => {
                                    tempArr = [...values.senders];
                                    tempArr.splice(index, 1);
                                    setFieldValue("senders", tempArr);
                                  }}
                                />
                              )}
                            </div>
                          )
                        }
                      ]}
                      dataSource={values.senders.map(name => {
                        return { sender: name };
                      })}
                      pagination={false}
                      bordered
                    />
                  )}
                </Col>
                <Col span={24}>
                  <FormInputWithButton
                    size="default"
                    inputProps={{
                      name: "personalSender",
                      value: values.personalSender,
                      onChange: handleChange,
                      placeholder: "Add Personal Number e.g. 614xxxxxxxx",
                      disabled: readMode,
                      containerClassname: "mb-0"
                    }}
                    buttonProps={{
                      label: "Add",
                      prefixIcon: <i className="fas fa-plus me-2" />,
                      onClick: () => {
                        let tempVal = values.personalSender?.trim();
                        if (tempVal) {
                          tempArr = [...values.personalSenders];
                          tempArr.push(values.personalSender);
                          setFieldValue("personalSenders", tempArr);
                          setFieldValue("personalSender", "");
                        }
                        return;
                      }
                    }}
                  />
                </Col>
                <Col span={24}>
                  {values.personalSenders && values.personalSenders.length > 0 && (
                    <AppTable
                      bordered
                      columns={[
                        {
                          title: "Personal Numbers",
                          dataIndex: "personalSenders",
                          key: "personalSenders",
                          render: (text, record, index) => (
                            <div className="d-flex align-items-center">
                              <span>{text}</span>
                              {!readMode && (
                                <i
                                  id={`personalSenders-${index}`}
                                  className="fas fa-trash-alt ms-auto"
                                  aria-hidden="true"
                                  onClick={e => {
                                    tempArr = [...values.personalSenders];
                                    tempArr.splice(index, 1);
                                    setFieldValue("personalSenders", tempArr);
                                  }}
                                />
                              )}
                            </div>
                          )
                        }
                      ]}
                      dataSource={values.personalSenders.map(name => {
                        return { personalSenders: name };
                      })}
                      pagination={false}
                    />
                  )}
                </Col>
              </Row> */}
              {/* <Divider /> */}
              <Row gutter={20}>
                <Col span={24}>
                  <Typography.Title level={4}>Account Settings</Typography.Title>
                </Col>
                <Col span={24}>
                  <FormCheckBoxInput
                    containerClassname="mb-0"
                    values={values}
                    errors={errors.allowedSharedSender}
                    touched={touched.allowedSharedSender}
                    handleChange={e => setFieldValue("allowedSharedSender", e.target.checked)}
                    name={"allowedSharedSender"}
                    placeholder={"Allow Shared Number?"}
                    disabled={readMode}
                  />
                </Col>
                <Col span={24}>
                  <FormCheckBoxInput
                    containerClassname="mb-0"
                    values={values}
                    errors={errors.allowReceivedSmsAsEmail}
                    touched={touched.allowReceivedSmsAsEmail}
                    handleChange={e => setFieldValue("allowReceivedSmsAsEmail", e.target.checked)}
                    name={"allowReceivedSmsAsEmail"}
                    placeholder={"Allow Received sms through email?"}
                    disabled={readMode}
                  />
                </Col>
                <Col span={24} className="d-flex">
                  <Switch
                    checked={values.newToken}
                    name="newToken"
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    onChange={e => setFieldValue("newToken", e)}
                    disabled={readMode}
                  />
                  <p className="ms-2">Token Settings {!values.newToken ? "All Tokens" : "New Tokens Only"}</p>
                </Col>
                <Col span={24} className="d-flex">
                  <Switch
                    checked={values.allowSubAccount}
                    name="allowSubAccount"
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    onChange={e => setFieldValue("allowSubAccount", e)}
                    disabled={readMode}
                  />
                  <p className="ms-2">Sub-Account {values.allowSubAccount ? "Allowed" : "Not Allowed"}</p>
                </Col>
              </Row>
              <Divider />
              <Row gutter={20}>
                {/* <Col span={24}>
                  <FormCheckBoxInput
                    values={values}
                    errors={errors.isCreditAllow}
                    touched={touched.isCreditAllow}
                    handleChange={e => {
                      handleChange(e);
                      setFieldValue("isCreditAllow", e.target.checked);
                    }}
                    name={"isCreditAllow"}
                    placeholder={"Allow Use To Buy Credits?"}
                  />
                </Col> */}
                <Col span={24}>
                  <Typography.Title level={4}>Message Settings</Typography.Title>
                </Col>
                <Col span={24} className="d-flex">
                  <Switch
                    checked={values.adminApproved}
                    name="adminApproved"
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    onChange={e => setFieldValue("adminApproved", e)}
                    disabled={readMode}
                  />
                  <p className="ms-2">Campaign Approval {values.adminApproved ? "Not Required" : "Reqiured"}</p>
                </Col>
                <Col span={24} className="d-flex">
                  <Switch
                    checked={!values.quickApproved}
                    name="quickApproved"
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    onChange={e => setFieldValue("quickApproved", !e)}
                    disabled={readMode}
                  />
                  <p className="ms-2">Quick SMS Approval {!values.quickApproved ? "Not Required" : "Reqiured"}</p>
                </Col>
              </Row>
              <Divider />
              <Row gutter={20}>
                <Col span={24}>
                  <Typography.Title level={4}>Credits Settings</Typography.Title>
                </Col>
                <Col span={12} className="d-flex">
                  <Switch
                    checked={values.profileType === "postpaid" ? true : false}
                    name="profileType"
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    onChange={e => {
                      if (!e) {
                        setFieldValue("profileType", "prepaid");
                      } else {
                        setFieldValue("profileType", "postpaid");
                      }
                    }}
                    disabled={readMode}
                  />
                  <p className="ms-2">Postpaid</p>
                </Col>
                <Col span={24} className="d-flex">
                  <Switch
                    checked={values.autoCredit}
                    name="autoCredit"
                    checkedChildren={<Icon type="check" />}
                    unCheckedChildren={<Icon type="close" />}
                    onChange={e => {
                      setFieldValue("autoCredit", e);
                    }}
                    disabled={readMode}
                  />
                  <p className="ms-2">Auto Credit</p>
                </Col>
                {values.autoCredit && (
                  <>
                    <Col span={24}>
                      <FormInput
                        containerClassname="mb-0"
                        label="Auto Credit Amount"
                        size="default"
                        name="autoCreditAmount"
                        placeholder="Auto Credit Amount"
                        disabled={readMode}
                        value={values.autoCreditAmount}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col span={12}>
                      <FormInput
                        containerClassname="mb-0"
                        label="Auto Credit Rate For SMS in cents"
                        size="default"
                        name="autoCreditRate"
                        placeholder="Auto Credit Rate For SMS"
                        disabled={readMode}
                        value={values?.autoCreditRate?.sms}
                        onChange={e => {
                          let temp = values.autoCreditRate;
                          temp.sms = e.target.value;
                          setFieldValue("autoCreditRate", temp);
                        }}
                      />
                    </Col>
                    <Col span={12}>
                      <FormInput
                        containerClassname="mb-0"
                        label="Auto Credit Rate For MMS in cents"
                        size="default"
                        name="autoCreditRate"
                        placeholder="Auto Credit Rate For MMS"
                        disabled={readMode}
                        value={values?.autoCreditRate?.mms}
                        onChange={e => {
                          let temp = values.autoCreditRate;
                          temp.mms = e.target.value;
                          setFieldValue("autoCreditRate", temp);
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
              <Divider />
              <Row gutter={20} type="flex">
                {!readMode && (
                  <Col>
                    <AppButton label={user && user._id ? "Save" : "Add User"} type="submit" disabled={isSubmitting} light onClick={handleSubmit} />
                  </Col>
                )}
                <Col>
                  <AppButton label="Close" type="button" onClick={onClose} disabled={isSubmitting} light withoutBg />
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default UserForm;
